class ToggleNav {
    constructor() {
        this.hamburger = document.querySelector(".hamburger");
        this.sidebar = document.querySelector(".sidebar_js");
        this.wrapper = document.querySelector(".navigation-sidebar-wrap");
        this.events();
    }

    events() {
        this.hamburger.addEventListener("click", (e) => {

            this.hamburger.classList.toggle("hamburger--open");
            this.sidebar.classList.toggle("open");
            this.wrapper.classList.toggle("open");
        });
    }
}

export default ToggleNav;